import {Component, OnInit} from '@angular/core';
import {MessageService} from '../../../../shared/message.service';
import { Message } from '../../../../shared/message';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {

  constructor(public messageService: MessageService) {
  }

  ngOnInit() {
  }

  removeMessage(message: Message): void {
    this.messageService.removeMessage(message);
  }
}
